module.exports = __webpack_public_path__ + "img/shopping-cart-03.9b82b69f.svg";